import { useEffect, useRef } from 'react'

import { Container, InconClose } from './style'

type AlertProps = {
  message?: string
  isActive: boolean
  onClickConfirmButton: (id: string) => void
  onClickCancelButton?: () => void
  RenderComponent?: () => JSX.Element
  onlyConfirm?: boolean
  title?: string
  textConfirm?: string
  textCancel?: string
}

export const Alert = ({
  message,
  onClickCancelButton,
  onClickConfirmButton,
  isActive,
  onlyConfirm,
  RenderComponent,
  title,
  textConfirm,
  textCancel
}: AlertProps): JSX.Element => {
  const ref = useRef<null>()

  useEffect(() => {
    function handleOutClick(event: any) {
      let value
      if (ref?.current) {
        value = ref?.current as HTMLDivElement
      }
      if (value && !value.contains(event.target)) {
        onClickCancelButton()
      }
    }
    if (isActive) {
      document.addEventListener('mousedown', handleOutClick)

      return () => {
        document.removeEventListener('mousedown', handleOutClick)
      }
    }
  }, [isActive])
  return (
    <Container isActive={isActive}>
      <main ref={ref}>
        <InconClose
          onClick={() => {
            if (onClickCancelButton) onClickCancelButton()
          }}
        />
        <h4>{title || 'Atenção'}</h4>
        <hr />
        {RenderComponent && <RenderComponent />}
        <h4 style={{ fontWeight: 500 }}>{message}</h4>
        <hr />
        <footer>
          {!onlyConfirm && (
            <button
              type="button"
              className="btn btn-light tn-active-light btn-sm sbold uppercase"
              onClick={onClickCancelButton}
              style={{ textAlign: 'center' }}
            >
              {textCancel || 'Cancelar'}
            </button>
          )}
          <button
            type="button"
            className="btn btn-primary btn-sm sbold uppercase"
            onClick={() => {
              onClickConfirmButton('')
            }}
          >
            {textConfirm || 'Ok'}
          </button>
        </footer>
      </main>
    </Container>
  )
}
